export default {
  "content": "<path d=\"M19 16h3v2h-3v3h-2v-8h2v3zM15 18H2v-2h13v2zM11 6h11v2H11v3H9V3h2v3zM7 8H2V6h5v2z\" fill=\"#7B61FF\"/>",
  "attrs": {
    "width": "24",
    "height": "24",
    "viewBox": "0 0 24 24",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};